import { ConfirmDialogIdentifier } from 'legacy/lut/components/shared/Confirm/actions'
import { ConfirmationDialog } from 'legacy/lut/components/shared/Confirm/ConfirmationDialog'
import React from 'react'

type Props = {
  isCommitmentSigned: boolean
}

export const deleteDialogIdentifier: ConfirmDialogIdentifier = 'ThingsToImproveDeleteDialog'

export function KeyInitiativeDeleteDialog(props: Props) {
  return (
    <ConfirmationDialog
      translation
      identifier={deleteDialogIdentifier}
      text="Do you want to delete item?"
      submitText="Delete"
      isCommitmentSigned={props.isCommitmentSigned}
    />
  )
}
